import * as React from 'react';
import { Theme, UIText1 } from '@cian/ui-kit';
import * as style from './BuildersTooltip.css';
import { BuilderLink } from '../BuilderLink';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';

export interface IBuildersTooltipProps {
  builders: INewbuildingBuilder[];
  onBuilderClick(): void;
}

export const BuildersTooltip: React.FC<IBuildersTooltipProps> = props => {
  const { builders, onBuilderClick } = props;

  return (
    <Theme theme="light">
      <div className={style['tooltip-content']}>
        <UIText1>Комплекс строят несколько компаний:</UIText1>
        <div className={style['builders-list']}>
          {builders.map((builder, index) => (
            <div key={builder.id}>
              <BuilderLink
                text={builder.name + (index < builders.length - 1 ? ', ' : '')}
                linkUrl={builder.profileUrl}
                onClick={onBuilderClick}
                fontSize="M"
              />
            </div>
          ))}
        </div>
      </div>
    </Theme>
  );
};
